/** True only when store attributes explicitly enable BOPIS. */
export const isStoreBopisEnabled = (store: { attributes?: { bopisEnabled?: boolean } } | null | undefined): boolean =>
    store?.attributes?.bopisEnabled === true;
